import type { AnchorHTMLAttributes, MouseEvent } from 'react';

interface SectionLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Section id to scroll to; omit to link to the top of the homepage. */
  section?: string;
  onNavigate?: () => void;
}

/**
 * A real, crawlable link to a homepage section (`/#services`). If the target section exists on
 * the current page it smooth-scrolls instead of navigating, matching the original button behavior.
 */
export default function SectionLink({ section, onNavigate, onClick, children, ...rest }: SectionLinkProps) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        e.preventDefault();
        element.scrollIntoView({ behavior: 'smooth' });
        onNavigate?.();
      }
    } else if (window.location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      onNavigate?.();
    }
  };

  return (
    <a href={section ? `/#${section}` : '/'} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
